export default __webpack_public_path__ + "static/media/twitter_bg_gray_color_black.c8f3be99.svg";